export default __webpack_public_path__ + "static/media/icon5.69d2e422.svg";